export default "__VITE_ASSET__BBRlIptW__"